import { freezeAdminPanelRegistry } from "../registry_engine";

import RestaurantCategoriesPanel from "../../../components/AdminPanel/RestaurantCategoriesPanel";
import MenuItemsPanel from "../../../components/AdminPanel/MenuItemsPanel";
import POSActivityAdminPanel from "../../../components/AdminPanel/POSActivityAdminPanel.jsx";
import AccountingPanel from "../../../components/AdminPanel/AccountingPanel";
import CashRegisterDashboardPanel from "../../../components/AdminPanel/CashRegisterDashboardPanel";
import TicketsPanel from "../../../components/AdminPanel/cash/TicketsPanel";
import LoyaltyAdminPage from "../LoyaltyAdminPage";
import CreateClientPanel from "../../../components/AdminPanel/CreateClientPanel";
import CreateCompanyPanel from "../../../components/AdminPanel/CreateCompanyPanel";
import UserListPanel from "../../../components/AdminPanel/UserListPanel";
import ClientListPanel from "../../../components/AdminPanel/ClientListPanel";
import CompanyListPanel from "../../../components/AdminPanel/CompanyListPanel";
import CreateUserPanelContainer from "../../../components/AdminPanel/CreateUserPanelContainer";
import restaurantStudioRegistration from "../../../components/RestaurantStudio/restaurantStudioRegistration";
import retailStudioRegistration from "../../../components/RetailStudio/retailStudioRegistration";
import CertPanel from "../../../components/AdminPanel/CertPanel";
import SupplierAdminPanel from "../../../components/AdminPanel/SupplierAdminPanel";
import SupplyChainInventoryAdminPanel from "../../../components/AdminPanel/SupplyChainInventoryAdminPanel";
import SupplyChainReplenishmentAdminPanel from "../../../components/AdminPanel/SupplyChainReplenishmentAdminPanel";
import SupplierPurchaseOrdersAdminPanel from "../../../components/AdminPanel/SupplierPurchaseOrdersAdminPanel";

import SupplierReceivingAdminPanel from "../../../components/AdminPanel/SupplierReceivingAdminPanel";
import HREmployeeDirectoryAdminPanel from "../../../components/AdminPanel/HREmployeeDirectoryAdminPanel";
export const ADMIN_PANEL_REGISTRY = freezeAdminPanelRegistry({
  hr_employees: {
    eyebrow: "Ressources humaines",
    title: "Annuaire salariés",
    description:
      "Consulter le référentiel Employee du scope société actif.",
    component: HREmployeeDirectoryAdminPanel,
    keyPrefix: "hr-employees",
  },

  create_user: {
    eyebrow: "Administration",
    title: "Créer un utilisateur",
    description:
      "Création d’un compte interne avec rôle, coordonnées, rattachement société et informations administratives.",
    component: CreateUserPanelContainer,
    keyPrefix: "create-user",
  },

  list_users: {
    eyebrow: "Administration",
    title: "Liste utilisateurs",
    description:
      "Consultation, modification rapide des rôles et suppression des comptes.",
    component: UserListPanel,
    keyPrefix: "users",
  },

  create_client: {
    eyebrow: "Administration",
    title: "Créer un compte client",
    description:
      "Création d’une fiche client avec coordonnées, compte rattaché et mot de passe initial.",
    component: CreateClientPanel,
    keyPrefix: "create-client",
  },

  list_clients: {
    eyebrow: "Administration",
    title: "Liste clients",
    description:
      "Consultation, modification, suppression et export des comptes clients.",
    component: ClientListPanel,
    keyPrefix: "clients",
  },

  create_company: {
    eyebrow: "Administration",
    title: "Créer une société",
    description:
      "Création d’une société rattachable aux utilisateurs, clients, activités et opérations de caisse.",
    component: CreateCompanyPanel,
    keyPrefix: "create-company",
  },

  list_companies: {
    eyebrow: "Administration",
    title: "Liste sociétés",
    description:
      "Consultation, modification et suppression logique des sociétés.",
    component: CompanyListPanel,
    keyPrefix: "companies",
  },

  restaurant_categories: {
    eyebrow: "Stock & restauration",
    title: "Catégories restauration",
    description:
      "Création, modification de l’ordre d’affichage et suppression des catégories du menu restaurant.",
    component: RestaurantCategoriesPanel,
    keyPrefix: "restaurant-categories",
  },

  menu_items: {
    eyebrow: "Stock & restauration",
    title: "Menu & stock",
    description:
      "Création, modification, suppression des articles restauration et suivi du stock disponible.",
    component: MenuItemsPanel,
    keyPrefix: "menu-items",
  },

  cash_management: {
    eyebrow: "Gestion Caisse",
    title: "Activités & catalogues caisse",
    description:
      "Création, modification, suppression des activités, catalogues produits, imports et paramètres de caisse.",
    component: POSActivityAdminPanel,
    keyPrefix: "activity",
  },

  accounting: {
    eyebrow: "Exports & comptabilité",
    title: "Comptabilité",
    description:
      "Consultation des écritures comptables générées depuis les ventes, lignes de ticket, paiements et montants de TVA.",
    component: AccountingPanel,
    keyPrefix: "accounting",
  },

  cash_dashboard_tickets: {
    eyebrow: "Gestion Caisse",
    title: "Tickets",
    description: "Réimpression, envoi email et correction des tickets.",
    component: TicketsPanel,
    keyPrefix: "tickets",
    props: {
      embedded: true,
    },
  },

  loyalty: {
    eyebrow: "Fidélité",
    title: "Fidélité",
    description:
      "Programmes, comptes, récompenses et transactions du Loyalty Engine.",
    component: LoyaltyAdminPage,
    keyPrefix: "loyalty",
    props: {
      embedded: true,
    },
  },

  cash_dashboard: {
    eyebrow: "Gestion Caisse",
    title: "Vue caisse",
    description:
      "Suivi du chiffre d’affaires, des tickets, du panier moyen et de la répartition des moyens de paiement.",
    component: CashRegisterDashboardPanel,
    keyPrefix: "cash-dashboard",
    props: {
      hideSubNav: true,
    },
    clearSearchParamsOnClose: true,
  },


  cash_dashboard_x: {
    eyebrow: "Gestion Caisse",
    title: "X de caisse",
    description: "Accès direct au rapport X depuis le raccourci Ventes.",
    component: CashRegisterDashboardPanel,
    keyPrefix: "cash-x",
    props: {
      autoOpenX: true,
      hideSubNav: true,
    },
    clearSearchParamsOnClose: true,
  },

  cash_dashboard_z: {
    eyebrow: "Gestion Caisse",
    title: "Clôture Z",
    description:
      "Ouverture, contrôle et clôture globale de la caisse société.",
    component: CashRegisterDashboardPanel,
    keyPrefix: "cash-z",
    props: {
      autoOpenZ: true,
      hideSubNav: true,
    },
    clearSearchParamsOnClose: true,
  },

  cash_dashboard_history: {
    eyebrow: "Gestion Caisse",
    title: "Historique Z",
    description: "Consultation des clôtures Z passées.",
    component: CashRegisterDashboardPanel,
    keyPrefix: "cash-history",
    props: {
      initialView: "history",
      hideSubNav: true,
    },
    clearSearchParamsOnClose: true,
  },

  certification: {
    eyebrow: "Certification",
    title: "Certificats",
    description:
      "Chaîne d’intégrité, exports fiscaux, signatures et certificats réglementaires.",
    component: CertPanel,
    keyPrefix: "certification",
  },

  supply_chain_suppliers: {
    eyebrow: "Supply Chain",
    title: "Fournisseurs",
    description:
      "Administration des fournisseurs, de leurs paramètres et de leur activation dans le Supply Chain Engine.",
    component: SupplierAdminPanel,
    keyPrefix: "supply-chain-suppliers",
  },

  supply_chain_inventory: {
    eyebrow: "Supply Chain",
    title: "Stock et couverture",
    description:
      "Consulter le stock, la vitesse de vente, la couverture et les risques de rupture.",
    component: SupplyChainInventoryAdminPanel,
    keyPrefix: "supply-chain-inventory",

  },

  supply_chain_replenishment: {
    eyebrow: "Supply Chain",
    title: "Réassort",
    description:
      "Générer et consulter une proposition de réassort optimisée sans créer de commande fournisseur.",
    component: SupplyChainReplenishmentAdminPanel,
    keyPrefix: "supply-chain-replenishment",
  },

  supply_chain_purchase_orders: {
    eyebrow: "Supply Chain",
    title: "Commandes fournisseurs",
    description:
      "Consulter les commandes fournisseurs, leurs lignes, références distributeur, quantités, montants et statuts.",
    component: SupplierPurchaseOrdersAdminPanel,
    keyPrefix: "supply-chain-purchase-orders",
  },

  supply_chain_receiving: {
    eyebrow: "Supply Chain",
    title: "Réception fournisseur",
    description:
      "Contrôler les quantités reçues, les écarts et les opérations de réception d’une commande fournisseur.",
    component: SupplierReceivingAdminPanel,
    keyPrefix: "supply-chain-receiving",
  },

  [restaurantStudioRegistration.panelMode]: {
    eyebrow: "Restaurant",
    title: "Restaurant Studio",
    description:
      "Conception des salles, implantation des tables et objets du restaurant.",
    component: restaurantStudioRegistration.AdminPanelComponent,
    loadStudioComponent:
      restaurantStudioRegistration.loadStudioComponent,
    keyPrefix: restaurantStudioRegistration.keyPrefix,
  },

  [retailStudioRegistration.panelMode]: {
    eyebrow: "Retail",
    title: "Retail Studio",
    description:
      "Conception et configuration de l'espace Retail Studio.",
    component: retailStudioRegistration.AdminPanelComponent,
    loadStudioComponent:
      retailStudioRegistration.loadStudioComponent,
    keyPrefix: retailStudioRegistration.keyPrefix,
  },
});

export function getAdminPanelConfig(panelMode) {
  return ADMIN_PANEL_REGISTRY[panelMode] || null;
}

export function isRegisteredAdminPanel(panelMode) {
  return Boolean(getAdminPanelConfig(panelMode));
}
